import React from 'react'
import {Component} from 'react'
import tariffaImage from './euro.png'
import Tooltip from '@material-ui/core/Tooltip';
import { connect } from 'react-redux'
import {fetchPath,selectNewIndex, selectNewMarkerStart2, selectNewMarkerEnd2,changeNomeFermataStart,changeNomeFermataEnd, changePercorsoDrawer,changePercorsoTariffa,changePositionTariffaStart} from '../../redux'
// import './ButtonMenuToc.css'

 class TariffaButton extends Component {
    
constructor(props){
    super(props);
    this.state = {
        buttonStyle: props.button,

        isToggleOn: true
      }
          // This binding is necessary to make `this` work in the callback
        
          
          this.handleClick = this.handleClick.bind(this);

}

handleClick() {
    
    this.setState(function(prevState) {
        this.props.openMenu(true)
        return {isToggleOn: !prevState.isToggleOn};
    });
    this.props.percorsoDrawer.percorsoDrawer = false
    this.props.percorsoTariffa.percorsoTariffa = true
}

render() {   
    return (
        // <Slide direction="left" in={this.state.isToggleOn } >
        <Tooltip title="Calcola Tariffa">
        <button  style={ this.state.buttonStyle} onClick={this.handleClick}>
            <img style={{width: '30px',height: '30px'}} src={tariffaImage} alt="trip"/>
        </button>
        </Tooltip>
        )
    }
}
const mapStateToProps = state => {
    return {
       
        markerStart2: state.markerStart2,
        markerEnd2: state.markerEnd2,
        nomeFermataStart:state.nomeFermataStart,
        nomeFermataEnd: state.nomeFermataEnd,
        percorsoDrawer : state.percorsoDrawer,
        percorsoTariffa : state.percorsoTariffa,
        positionTariffaStart : state.positionTariffaStart
  
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
       
        markerStart2: (marker) => dispatch(selectNewMarkerStart2(marker)),
        markerEnd2: (marker) => dispatch(selectNewMarkerEnd2(marker)),
        changeNomeFermataStart :(nomeFermataStart) => dispatch(changeNomeFermataStart(nomeFermataStart)),
        changeNomeFermataEnd :(nomeFermataEnd) => dispatch(changeNomeFermataEnd(nomeFermataEnd)),
        changePercorsoDrawer: (percorsoDrawer) => dispatch(changePercorsoDrawer(percorsoDrawer)),
        changePercorsoTariffa: (percorsoTariffa) => dispatch(changePercorsoTariffa(percorsoTariffa)),
        changePositionTariffaStart : (positionTariffaStart) => dispatch(changePositionTariffaStart(positionTariffaStart))
  
    }
  }
  
  
  
  
  export default connect(mapStateToProps,mapDispatchToProps) (TariffaButton)